import React from 'react'
import { Box, Grid, Modal, Typography } from '@mui/material'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { AuthContext } from '../../../contexts/AuthContext'
import { BiX } from 'react-icons/bi'
import {
  ButtonLoading,
  InputText,
  BasketLoading,
  SelectInput,
  OTPInput,
  ResendOTPButton,
} from '../../Simple/'
import Alerts from '../../Simple/Alerts'

import './styles.css'

export default function ValidPhone({ show, onClose }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { sttCtxChkt, actionsChkt, loadCh, inpsChkt, uiControlsChkt } =
    React.useContext(CheckoutContext)

  async function actionValidPhone() {
    await actionsChkt.EnviarCodigoPhone()
  }

  async function handleVerifyCode() {
    await actionsChkt.ValidarCodigoPhone()
  }

  function ValidarDados() {
    // inpsChkt.pais e inpsChkt.phone são os campos que o usuário vai preencher
    if (!inpsChkt.pais || inpsChkt.phone.length < 14) {
      // console.log('Preencha todos os campos')
      return true
    } else {
      return false
    }
  }

  return (
    <Modal open={show} onClose={onClose} className='contain-overlay-vp'>
      <>
        <div className='contain-content-vp'>
          {loadCh.validPhone && sttAuthCtx.isMobile && <BasketLoading />}
          <BiX size={25} className='icon-close-vp' onClick={onClose} />
          {sttCtxChkt.modeVP === 'informar' ? (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant='body1' sx={{ textAlign: 'left' }}>
                    Antes de pagar pelo site, você precisa validar seu número de telefone
                  </Typography>
                  <Typography variant='h6' sx={{ textAlign: 'left', fontWeight: 'bold' }}>
                    Esse é seu número?
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <SelectInput
                    label='País*'
                    value={inpsChkt.pais}
                    onChange={e => {
                      actionsChkt.handleInpsChkt('pais', e.target.value)
                    }}
                    options={[
                      { value: '+55', label: '🇧🇷 (+55)' },
                      { value: '+54', label: '🇦🇷 (+54)' },
                      { value: '+598', label: '🇺🇾 (+598)' },
                      { value: '+595', label: '🇵🇾 (+595)' },
                      { value: '+591', label: '🇧🇴 (+591)' },
                      { value: '+51', label: '🇵🇪 (+51)' },
                      { value: '+57', label: '🇨🇴 (+57)' },
                      { value: '+58', label: '🇻🇪 (+58)' },
                    ]}
                  />
                </Grid>
                <Grid item xs={7}>
                  <InputText
                    type='tel'
                    label='Telefone*'
                    value={inpsChkt.phone}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                      }
                    }}
                    onChange={e => {
                      actionsChkt.handleInpsChkt('phone', e.target.value)
                    }}
                  />
                </Grid>

                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonLoading
                    disabled={ValidarDados()}
                    onClick={async () => {
                      await Alerts.question(
                        'Confirme seu número',
                        `${inpsChkt.pais} ${inpsChkt.phone}?`,
                        actionValidPhone,
                      )
                    }}
                    loading={loadCh.validPhone}
                    fullWidth={sttAuthCtx.isMobile}
                    sx={!sttAuthCtx.isMobile ? { width: '250px' } : {}}
                  >
                    Continuar
                  </ButtonLoading>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Box sx={{ px: 1.5, py: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant='body1' sx={{ textAlign: 'left' }}>
                      Digite o código de 6 dígitos que enviamos para
                    </Typography>
                    <Typography variant='h6' sx={{ textAlign: 'left', fontWeight: 'bold' }}>
                      {inpsChkt.pais + ' ' + inpsChkt.phone}
                    </Typography>
                  </Grid>
                </Grid>
                <OTPInput
                  value={inpsChkt.otpCode}
                  onChange={actionsChkt.handleInpsChkt}
                  error={uiControlsChkt.codeValido !== null ? !uiControlsChkt.codeValido : false}
                  helperText={uiControlsChkt.otpCodeHelperText}
                />
                <ButtonLoading
                  fullWidth
                  disabled={inpsChkt.otpCode.length !== 6}
                  variant='contained'
                  onClick={handleVerifyCode}
                  loading={loadCh.validPhone}
                >
                  Continuar
                </ButtonLoading>
                <ResendOTPButton
                  seconds={60}
                  createdAt={new Date()}
                  waitingText={'Reenviar código em {time}'}
                  actionText={'Reenviar código'} // 🔥 Texto do botão
                  onResend={() => {
                    actionValidPhone()
                  }}
                />
              </Box>
            </>
          )}
        </div>
      </>
    </Modal>
  )
}
